/** @jsx jsx */
import { jsx } from "theme-ui"
import { Component } from "react"
import PropTypes from "prop-types"

import LanguageSwitcher from "./language-switcher"
import SearchTriggerConsumer from "./search-trigger-consumer"
import NavigationMainItem from "./navigation-main-item"
import { ab } from "../theme"

class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navMenu: props.navMenu,
      currentLanguage: props.currentLanguage,
      currentURL: props.currentURL,
      currentMode: props.currentMode,
      activeSubmenu: "",
      seoLinks: props.seoLinks,
    }
    this.setActiveSubmenu = this.setActiveSubmenu.bind(this)
  }

  setActiveSubmenu(submenu) {
    this.setState({
      activeSubmenu: submenu,
    })
  }

  render() {
    let mainMenu = []

    for (
      var i = 0;
      i < this.state.navMenu[this.state.currentLanguage]["children"].length;
      i++
    ) {
      let iconName = this.state.navMenu[this.state.currentLanguage]["children"][
        i
      ]["icon"]
      let active =
        this.state.navMenu[this.state.currentLanguage]["children"][i][
          "mode"
        ] === this.state.currentMode
      let displayName = this.state.navMenu[this.state.currentLanguage][
        "children"
      ][i]["displayName"]
      let navigationItems = this.state.navMenu[this.state.currentLanguage][
        "children"
      ][i]["children"]
      let extras = this.state.navMenu[this.state.currentLanguage]["children"][
        i
      ]["extras"]
      let url = this.state.navMenu[this.state.currentLanguage]["children"][i][
        "url"
      ]["cached_url"]

      if (
        this.state.navMenu[this.state.currentLanguage]["children"][i]["url"][
          "linktype"
        ] === "story"
      ) {
        url =
          this.state.navMenu[this.state.currentLanguage]["children"][i]["url"][
            "story"
          ] &&
          this.state.navMenu[this.state.currentLanguage]["children"][i]["url"][
            "story"
          ]["full_slug"]
            ? this.state.navMenu[this.state.currentLanguage]["children"][i][
                "url"
              ]["story"]["full_slug"]
            : url
      }
      if (this.state.currentLanguage !== "de") {
        url = url.startsWith(this.state.currentLanguage + "/")
          ? url
          : this.state.currentLanguage + "/" + url
      }

      let currentPage = this.state.navMenu[this.state.currentLanguage][
        "children"
      ][i]["currentPage"]

      mainMenu.push(
        <NavigationMainItem
          key={i}
          iconName={iconName}
          active={active}
          currentSub={this.state.activeSubmenu}
          openFn={this.setActiveSubmenu}
          displayName={displayName}
          currentPage={currentPage}
          url={url}
          currentLanguage={this.state.currentLanguage}
          navigationItems={navigationItems}
          extras={extras}
          seoLinks={this.state.seoLinks}
        />
      )
    }

    return (
      <div className="navigation">
        <div
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            position: "fixed",
            zIndex: 100,
            top: 0,
            display: ab({ _: "none", sm: "block" }),
            animationName: this.state.activeSubmenu ? "FadeIn" : "FadeOut",
            animationDuration: "300ms",
            animationFillMode: "forwards",
            "@keyframes FadeIn": {
              "0%": {
                width: "0vw",
                height: "0vh",
                opacity: 0,
              },
              "1%": {
                width: "100vw",
                height: "100vh",
              },
              "30%": {
                opacity: 0.5,
              },
              "100%": {
                opacity: 1,
                width: "100vw",
                height: "100vh",
              },
            },
            "@keyframes FadeOut": {
              form: {
                opacity: 1,
                width: "100vw",
                height: "100vh",
              },
              to: {
                opacity: 0,
                zIndex: -99,
                width: "0vw",
                height: "0vh",
              },
            },
          }}
          className="navigation-overlay"
          role="button"
          tabIndex="0"
          onKeyPress={() => this.setActiveSubmenu("")}
          onClick={() => this.setActiveSubmenu("")}
        ></div>
        <div sx={{ maxWidth: "max", margin: "auto" }}>
          <div sx={{ float: "right", width: "navigationDesktopWidth" }}>
            <div
              sx={{
                variant: this.state.activeSubmenu
                  ? "navigation.containerOpen"
                  : "navigation.container",
              }}
              className="navigation-container"
            >
              <div
                sx={{
                  variant: "navigation.mainContainer",
                  cursor: "pointer",
                }}
              >
                <div
                  sx={{ variant: "navigation.searchTrigger" }}
                  className="search-trigger-container"
                >
                  <SearchTriggerConsumer />
                </div>
                {mainMenu}

                <div sx={{ variant: "navigation.languageSwitcher" }}>
                  <LanguageSwitcher
                    currentLanguage={this.state.currentLanguage}
                    currentURL={this.state.currentURL}
                    seoLinks={this.state.seoLinks}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Navigation Mobile Spacer */}
        <div
          sx={{ variant: "navigation.spacer", display: ab({ md: "none" }) }}
        ></div>
      </div>
    )
  }
}

Navigation.propTypes = {
  navMenu: PropTypes.object.isRequired,
  seoLinks: PropTypes.object.isRequired,
  currentMode: PropTypes.string.isRequired,
  currentLanguage: PropTypes.oneOf(["de", "en"]).isRequired,
  currentURL: PropTypes.string.isRequired,
}

Navigation.defaultProps = {
  currentMode: "default",
  currentLanguage: "de",
  seoLinks: {},
}

export default Navigation
